import React, { useState, useEffect } from "react";
import { HashLink as Link } from "react-router-hash-link";
import Collapse from "react-bootstrap/Collapse";
import { profileDb } from "../../../db/dbClasses";
import FooterIconBelt from "../../Miscellaneous/FooterIconBelt.component";
import { navLinks } from "./NavigationTabs";
import { LogoIcon } from "../../Miscellaneous/Icons.component";
import {
  LinkButtonTab,
  HoverWrapper,
  SmallNavbarLink,
} from "../../Miscellaneous/NavbarLinks.component";

const Navbar = (props) => {
  const [open, setOpen] = useState(false);
  const [data, setData] = useState({});
  const getData = async () => {
    const result = await profileDb.read();
    setData(result[0]);
  };
  useEffect(() => {
    getData();
  }, []);

  const toggleOpen = () => {
    setOpen(!open);
  };
  return (
    <React.Fragment>
      <div className="d-block d-lg-none">
        <nav className="navbar bg-dark navbar-dark text-light">
          <button
            className="navbar-toggler"
            style={{
              marginLeft: "10px",
              border: "none",
            }}
            type="button"
            onClick={() => toggleOpen()}
          >
            <span className="navbar-toggler-icon"></span>
          </button>
          <div
            style={{
              marginRight: "20px",
            }}
          >
            <Link to="/home" className="nav-link">
              <LogoIcon last_name={data?.last_name} />
            </Link>
          </div>
          <Collapse in={open}>
            <div className="navbar-collapse">
              <ul className="navbar-nav d-flex align-items-start justify-content-center p-4 w-80 mx-auto">
                {navLinks.map((elem, idx) => (
                  <li
                    className="nav-item w-100"
                    key={elem?.title}
                    style={{
                      borderTop: "1px solid rgba(255, 255, 255, 0.3)",
                      borderBottom:
                        idx === navLinks.length - 1
                          ? "1px solid rgba(255, 255, 255, 0.3)"
                          : "none",
                    }}
                  >
                    <HoverWrapper
                      child={SmallNavbarLink}
                      elem={elem}
                      color={props.color}
                    />
                  </li>
                ))}
                <li className="nav-item d-flex align-items-center flex-row justify-content-around w-100 mt-3 ">
                  <FooterIconBelt
                    socials={data?.socials}
                    size={30}
                    stretchWidth={80}
                  />
                </li>
              </ul>
            </div>
          </Collapse>
        </nav>
      </div>
      <nav className="d-none d-lg-block nav-scrollable">
        <div
          className="navbar-primary bg-dark text-light d-flex flex-column align-items-start justify-content-between"
          style={{
            height: "100vh",
          }}
        >
          <div style={{ overflowY: "auto" }}>
            <Link to="/admin" className="nav-link">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                height="1rem"
                width="1rem"
                fill="none"
                viewBox="0 0 24 24"
                stroke="white"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"
                />
              </svg>
            </Link>
            {/* </div> */}
            <ul
              className="d-flex flex-column align-items-center text-center mt-4"
              style={{
                overflowY: "auto",
                overflowX: "hidden",
                height: "auto",
              }}
            >
              <li className="rounded-circle mx-auto w-80">
                <img
                  className="bg-headshot"
                  src={data?.photo_navbar}
                  alt="profile"
                  style={{
                    width: "150px",
                    height: "150px",
                    borderRadius: "50%",
                    objectFit: "cover",
                  }}
                />
              </li>
              <li className="w-80 mt-2 font-montserrat">
                <h3 className="fw-l">
                  {data?.first_name} {data?.last_name}
                </h3>
                <h5 className="fw-xl text-white-50 mt-3">{data?.university}</h5>
              </li>
              <br />
              {navLinks.map((elem, idx) => (
                <li key={elem?.title}>
                  <LinkButtonTab
                    {...elem}
                    smooth="true"
                    svgColor={props.color || "orange"}
                    isfirst={idx === 0}
                  />
                </li>
              ))}
            </ul>
          </div>
          <div className="">
            <div
              className={`rounded-0 text-white fw-l d-flex flex-column align-items-center justify-content-center p-2`}
              style={{
                width: "300px",
                backgroundColor: "#191b1c",
                transition: "0.1s ease-in-out",
                textAlign: "center",
                textDecoration: "none",
                borderTop: "1px solid rgba(255, 255, 255, 0.1)",
                verticalAlign: "middle",
              }}
            >
              <FooterIconBelt socials={data?.socials} />
              <span style={{ fontSize: "14px" }}>
                ©2021 <span>{`${data?.first_name} ${data?.last_name}`}</span>{" "}
              </span>
            </div>
          </div>
        </div>
      </nav>
    </React.Fragment>
  );
};

export default Navbar;
